import { render } from "./TreeDemo.vue?vue&type=template&id=700e7f2b"
import script from "./TreeDemo.vue?vue&type=script&lang=js"
export * from "./TreeDemo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__